import React from 'react';
import { motion } from 'framer-motion';

const Methodology = () => {
  const steps = [
    {
      number: "1",
      title: "Analyse",
      desc: "Reconnaissance passive et active. Cartographie de la surface d'attaque et identification des points d'entrée potentiels."
    },
    {
      number: "2",
      title: "Exploitation",
      desc: "Tentatives d'intrusion éthiques pour valider les vulnérabilités et mesurer l'impact réel sur votre activité."
    },
    {
      number: "3",
      title: "Rapport",
      desc: "Livraison d'un rapport détaillé incluant un plan de remédiation priorisé et une synthèse pour la direction."
    }
  ];

  return (
    <section className="w-full bg-[#0a1120] py-16 lg:py-24 px-6 flex justify-center overflow-hidden font-sans relative">
      
      {/* ICÔNE TERMINAL EN SVG (Remplace ig2) */}
      <div className="absolute top-0 right-0 w-[250px] lg:w-[400px] opacity-5 pointer-events-none translate-x-10 -translate-y-10">
        <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="4 17 10 11 4 5"></polyline>
          <line x1="12" y1="19" x2="20" y2="19"></line>
        </svg>
      </div>

      <div className="max-w-[1000px] w-full relative z-10">
        
        {/* HEADER SECTION */}
        <div className="mb-16 lg:mb-20">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-white text-[32px] lg:text-[42px] font-black mb-4 tracking-tight"
          >
            Notre Méthodologie
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-slate-400 text-[14px] lg:text-[16px] max-w-[550px] font-medium leading-relaxed"
          >
            Un processus rigoureux pour assurer une couverture maximale et des résultats exploitables.
          </motion.p>
        </div>

        {/* STEPS CONTAINER */}
        <div className="relative">
          
          {/* Ligne de connexion horizontale (Visible sur Desktop) */}
          <div className="hidden lg:block absolute top-[45px] left-0 w-full h-[1px] bg-slate-800 z-0" />
          
          {/* Ligne bleue animée qui se dessine au scroll */}
          <motion.div 
            initial={{ width: 0 }}
            whileInView={{ width: "100%" }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, ease: "easeInOut" }}
            className="hidden lg:block absolute top-[45px] left-0 h-[1px] bg-gradient-to-r from-blue-600 via-blue-400 to-transparent z-0"
          />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-8">
            {steps.map((step, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.2 }}
                className="flex flex-col items-center lg:items-start text-center lg:text-left relative z-10"
              >
                {/* Cercle Numéroté avec effet Glow */}
                <div className="relative mb-8">
                  <div className="w-[90px] h-[90px] rounded-full bg-[#3b82f6] flex items-center justify-center text-white text-[32px] font-black shadow-[0_0_30px_rgba(59,130,246,0.4)] transition-transform hover:scale-110 duration-300 relative z-10">
                    {step.number}
                  </div>
                  {/* Aura lumineuse pulsante derrière le chiffre */}
                  <div className="absolute inset-0 rounded-full bg-blue-500/20 animate-pulse blur-xl z-0" />
                </div>

                <h3 className="text-white text-[22px] font-bold mb-4 tracking-tight">
                  {step.title}
                </h3>
                
                <p className="text-slate-400 text-[14px] leading-relaxed font-medium opacity-90 lg:pr-4">
                  {step.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default Methodology;